'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const i18n = require('i18next');
const SyncStateModel = require('system/domain/entity/sync-state');
const EditModeMixin = require('system/domain/entity/edit-mode-mixin');
const Snackbar = require('common/util/snackbar');

let ElementModel = Backbone.Model.extend({
    /**
     * Diagram に存在する Model のベースクラス。
     *
     * 継承して利用する。
     * @example
     * var MyModel = ElementModel.extend({
         *    ...
         * })
     * @constructs
     */

    movable: false,
    selected: false,
    editing: false,

    initialize: function (params) {
        this.creating = false;
        this.deleting = false;

        params = params ? params : {};
        let syncState = params.syncState || SyncStateModel.States.synced;
        this.syncState = new SyncStateModel({state: syncState});
        this.listenTo(this.syncState, 'conflict', function() {
            Snackbar.notify.danger({
                title: i18n.t('diagram:alert.elements.conflict',
                    {name: this.get('name')})
            });
        });
        this.listenTo(this.syncState, 'change:state',
            function(state) {
                this.trigger('change:state', state);
            });
    },
    remove: function () {
        this.set({deleted: true}, {nosync: true});
        this.trigger('remove');
        this.syncState.setSynced();
    },
    toJSON: function () {
        let j = ElementModel.__super__.toJSON.call(this);
        j.id = this.id;
        return j;
    },

    getName: function() {
        return this.get('name');
    },

    click: function () {
        this.invertSelect();
    },
    doubleClick: function () {
        this.trigger('dblclick', this);
        this.select();
    },
    select: function () {
        if (!this.selected) {
            this.selected = true;
            this.trigger('before:select', this);
            this.trigger('select', this);
            this.trigger('change', this);
        }
    },
    deselect: function () {
        if (this.selected) {
            this.selected = false;
            this.trigger('before:deselect', this);
            this.trigger('deselect', this);
            this.trigger('change', this);
        }
    },
    highlight: function () {
        if (!this.highlighted) {
            this.highlighted = true;
            this.trigger('highlight', this);
            this.trigger('change', this);
        }
    },
    dehighlight: function () {
        if (this.highlighted) {
            this.highlighted = false;
            this.trigger('dehighlight', this);
            this.trigger('change', this);
        }
    },
    invertSelect: function () {
        if (this.selected) {
            this.deselect();
        } else {
            this.select();
        }
    },

    toString: function (options) {
        let id = this.id;
        options = _.extend({}, options);
        if (options.idLength) {
            id = this.id.slice(0, options.idLength);
        }
        return `#${id}`;
    },

    hasRelatedComment: function() {
        return this.get('has_comment');
    },

    hasRelatedTask: function() {
        return this.get('has_task');
    }
}, {
    _classes: {},
    _params: {},

    /**
     * モデルを拡張したクラスを定義する。
     *
     * @param type {String} - クラス名
     * @param params {Object} - パラメータ
     */
    define: function (type, params) {
        if (!this._classes) {
            this._classes = {};
        }
        this._params[type] = params;

        let defaults = _.extend({}, this.defaults);
        defaults = _.extend(defaults, this.params);
        defaults['deleted'] = false;
        params.defaults = defaults;
        this._classes[type] = this.extend(params);
    },

    /**
     * type で指定したモデルを instantiate する。
     *
     * @lends module:models/diagram/element-model.ElementModel
     * @param type {String} - クラス名
     * @param params {Object} - パラメータ
     */
    create: function (type, params) {
        let klass = this._classes[type];
        if (!klass) {
            throw 'No such klass: ' + type;
        }
        params['type'] = type;

        return new klass(params, {silent: true});
    },

    /**
     * クラス定義時のパラメータを取得する。
     * お茶を濁すためのもの。そのうち改修。
     */
    getParams: function(type) {
        return this._params[type];
    }
});

_.extend(ElementModel.prototype, EditModeMixin);

module.exports = ElementModel;



// WEBPACK FOOTER //
// ./system/domain/entity/element.js